import React from 'react';
export function Header() {
  return <header className="w-full bg-white py-4 px-4 sm:px-6 border-b border-gray-200 shadow-sm" data-id="element-201">
      <div className="max-w-4xl mx-auto flex justify-center md:justify-start" data-id="element-202">
        <a href="https://www.neurotoned.com/" className="flex items-center" data-id="element-203">
          <span className="text-xl font-bold text-purple-700" data-id="element-204">Unfreeze</span>
          <span className="text-xl font-light text-teal-600 ml-1" data-id="element-205">
            by Neurotoned
          </span>
        </a>
      </div>
    </header>;
}